import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, HostListener, inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { CmsSearchBoxComponent, WindowRef, RoutingService, OccEndpointsService } from '@spartacus/core';
import { CmsComponentData, SearchBoxComponent, SearchBoxComponentService } from '@spartacus/storefront';
//import { WebtrekkSmartPixelAngular } from '@webtrekk-smart-pixel/angular';
import { RecentSearchService } from 'src/app/services/feature/Recent-Search/recent-search.service';
import { KbLoadingService } from 'src/app/services/sapSpartacus/loading.service';
import { searchWebtrekkTrackingService } from './searchWebtrekkTrackingService';
@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false
})
export class SearchBarComponent extends SearchBoxComponent {
  showValidation: boolean = false;
  closeResultBox: boolean = false;
  recentSearches: any[] = [];
  searchInput: string = '';
  @ViewChild('fileInput') fileInput: ElementRef;
  searchText: string = '';
  platformId = inject(PLATFORM_ID);
  constructor(protected override searchBoxComponentService: SearchBoxComponentService,
    protected override componentData: CmsComponentData<CmsSearchBoxComponent>,
    protected override winRef: WindowRef,
    protected override routingService: RoutingService,
    public cdr: ChangeDetectorRef,
    private recentSearch: RecentSearchService,
    public kbloader: KbLoadingService,
    //private pixel: WebtrekkSmartPixelAngular,
    private webtrekkTrackingService: searchWebtrekkTrackingService
  ) {
    super(searchBoxComponentService, componentData, winRef, routingService);
    this.WebTrekk_Search();
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInsideComponent = (event.target as HTMLElement).closest('app-search-bar');
    if (!clickedInsideComponent) {
      this.hideRecentSearches(); // Hide the dropdown when clicking outside the component
    }
  }
  override ngOnInit(): void {
    this.updateRecentSearches();
  }
  updateRecentSearches(): void {
    this.recentSearches = this.recentSearch.getRecentSearches('NewRecentSearchBox');
  }
  override search(query: string): void {
    if (query.toLowerCase().startsWith("cart")) {
      query = "Cart" + query.slice(4);
    }
    this.searchBoxComponentService.search(query, this.config);

    this.checkOuterResults();
    this.open();
  }
  onSearch(event: Event): void {

    event.preventDefault();
    this.WebTrekk_Search();
    if (this.searchInput.trim().length > 0) {
      this.recentSearch.saveRecentSearch(this.searchInput, 'NewRecentSearchBox');
      this.updateRecentSearches();
    }
  }
  WebTrekk_Search() {
    /*   this.pixel.page('Search', {
        search: this.searchInput.trim(),
      }); */
    this.webtrekkTrackingService.trackAction(this.searchInput.trim());
  }
  onSearchPDPLink(code): void {
    this.recentSearch.saveRecentSearch(code, 'NewRecentSearchBox');
    this.updateRecentSearches();
  }
  onSearchInput(event: any): void {
    this.searchInput = event.target.value;
    if (this.searchText?.toLowerCase().startsWith('cart')) {
      this.searchText = 'Cart' + this.searchText.slice(4);
    }
    if (this.searchInput.length > 0) {
      this.hideRecentSearches();
    } else {
      this.showRecentSearches();
    }
  }
  clearRecentSearch(): void {
    this.closeResultBox = false;
    this.hideRecentSearches();
  }
  showRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.mobileSearch .RecentSearchPopUP') ||
        document.querySelector('.RecentSearchPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.add('show');
      }
    }
  }

  hideRecentSearches(): void {
    if (isPlatformBrowser(this.platformId)) {
      const recentSearchPopup = document.querySelector('.mobileSearch .RecentSearchPopUP') ||
        document.querySelector('.RecentSearchPopUP');
      if (recentSearchPopup) {
        recentSearchPopup.classList.remove('show');
      }
    }
  }

  showValidationError(searchinput: any) {
    this.showValidation = !(searchinput.length >= 3 || searchinput.length === 0);
    this.closeResultBox = searchinput.length >= 3;
  }
  closeValidationMsg(length: any) {
    this.closeResultBox = false;
    if ((length.length == 0) || (length.length >= 3)) {
      this.showValidation = false;
    } else {
      this.showValidation = true;
    }
  }

  removeSpecialCharacters(input: string): string {
    const regex = /[^a-zA-Z0-9\s]/g;
    return input.replace(regex, '');
  }

  override launchSearchResult(query: string): void {
    //making api call for 3 letters alone by client request
    if (!query || query.trim().length <= 2) {
      return;
    }
    this.close();

    this.recentSearch.launchSearchPage(query);
  }

}
